module.exports = __webpack_public_path__ + "img/thumb_32.c7b31284.jpg";